import { render, staticRenderFns } from "./Smiles.vue?vue&type=template&id=a6f82e88&"
import script from "./Smiles.vue?vue&type=script&lang=js&"
export * from "./Smiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports